import { type FormEvent } from "react";
import type { Form2State } from "./state";

interface Props {
  form: Form2State;
  loading: boolean;
  onChange: (patch: Partial<Form2State>) => void;
  onSubmit: () => void;
}

export function Step2Review({ form, loading, onChange, onSubmit }: Props) {
  function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!form.firmenname.trim()) return;
    onSubmit();
  }
  return (
    <section className="wizard-section" data-step="2">
      <h2 className="form-title">Schritt 2: Unternehmensdaten prüfen</h2>
      <p className="form-description">
        Bitte prüfen und ggf. ergänzen. Dann Bericht anlegen und Fragebogen erzeugen.
      </p>
      <form className="report-form" onSubmit={submit}>
        <div className="form-row">
          <label htmlFor="review-firmenname">Firmenname</label>
          <input
            id="review-firmenname"
            type="text"
            placeholder="z. B. Conufactur GmbH"
            value={form.firmenname}
            onChange={(e) => onChange({ firmenname: e.target.value })}
          />
        </div>
        <div className="form-row">
          <label htmlFor="review-branche">Branche / Geschäftsmodell</label>
          <input
            id="review-branche"
            type="text"
            placeholder="Was macht das Unternehmen?"
            value={form.branche}
            onChange={(e) => onChange({ branche: e.target.value })}
          />
        </div>
        <div className="form-row">
          <label htmlFor="review-inhaber">Inhaber / Geschäftsführung</label>
          <input
            id="review-inhaber"
            type="text"
            placeholder="Name(n)"
            value={form.inhaber}
            onChange={(e) => onChange({ inhaber: e.target.value })}
          />
        </div>
        <div className="form-row">
          <label htmlFor="review-standort">Standort</label>
          <input
            id="review-standort"
            type="text"
            placeholder="Ort / Region"
            value={form.standort}
            onChange={(e) => onChange({ standort: e.target.value })}
          />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading || !form.firmenname.trim()}>
            {loading ? "Wird geladen…" : "Bericht anlegen und Fragebogen ausfüllen"}
          </button>
        </div>
      </form>
    </section>
  );
}
